var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14.584 7.594c.11.26.11.546 0 .807-.524 1.242-2.428 4.93-6.586 4.93-4.16 0-6.062-3.689-6.584-4.931-.11-.26-.11-.545 0-.805.522-1.242 2.424-4.93 6.584-4.93 4.158 0 6.062 3.687 6.586 4.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.666 7.997a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0"
  })));
};
export default SvgEye;